import React from 'react'
import { PublicPageButton } from 'src/public-pages/shared/components/public-page-button'
import { PublicPageHeading } from 'src/public-pages/shared/components/public-page-heading'
import { PublicPageText } from 'src/public-pages/shared/components/public-page-text'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { Error500Icon } from 'src/shared/icons/error-500-icon'
import {
  WebsiteButtonsInterface,
  WebsiteThemeInterface,
  WebsiteTypographySettingsStylesInterface,
} from 'src/shared/types/website-settings-types'

export interface InternalServerErrorContentProps {
  homePageUrl?: string
  heading?: WebsiteTypographySettingsStylesInterface
  paragraph?: WebsiteTypographySettingsStylesInterface
  theme?: WebsiteThemeInterface
  button?: Partial<WebsiteButtonsInterface>
  isButtonShown?: boolean
}

export const InternalServerErrorContent = ({
  homePageUrl = '/',
  heading,
  paragraph,
  theme,
  button,
  isButtonShown,
}: InternalServerErrorContentProps) => {
  const accentColor = theme?.buttons.primaryButtonBackgroundColor

  const redirect = () => {
    window.location.href = homePageUrl
  }
  const { t } = useTypedTranslation()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <Error500Icon fill={accentColor} />

      <PublicPageHeading
        heading={heading}
        theme={theme}
        style={{ marginBottom: '24px' }}
      >
        {t('website_public_page.internal-server-error-content.title')}
      </PublicPageHeading>

      <PublicPageText
        paragraph={paragraph}
        theme={theme}
        textAlign="center"
        style={isButtonShown ? { marginBottom: '24px' } : undefined}
      >
        {t('website_public_page.internal-server-error-content.sub_title')}
      </PublicPageText>

      {isButtonShown && (
        <PublicPageButton
          button={button}
          theme={theme}
          text={t('website_public_page.thank_you_content.button_text')}
          onClick={redirect}
          width="100%"
          paragraph={paragraph}
        />
      )}
    </div>
  )
}
